/* eslint-disable */
import { DOCKETS_LIST_SETTINGS } from '../Dockets.types';

/**
 * Action to add settings to the dockets
 * @param {Array} address The address
 * @returns {ActionCreator<FromPayload<Array<string>, ActionMeta, DOCKET_ADDRESS_ADDED>>} The created `Action`
 */
const docketsListSettings = (listSettings) => ({ fromPayload }) => {
  return fromPayload(listSettings, { debounce: true }, DOCKETS_LIST_SETTINGS);
};

export default docketsListSettings;
